<template>
    <div>
        <div>好物统计中心</div>
        <!-- <Balance ref="Balance" :hide_ts="1"></Balance> -->
        <div style="display: flex;justify-content:space-between;margin-top: 10px;">
            <div style="width: 230px;display: flex;">
                <el-input size="small" placeholder="ID/名称" clearable v-model="find_value"
                    @keyup.enter.native="haowu_list(); haowu_page = 1" @clear="haowu_list(); haowu_page = 1"></el-input>
                <el-button size="small" type="primary" style="margin-left: 5px;"
                    @click="haowu_list(); haowu_page = 1">查找</el-button>
            </div>
            <!-- <el-button type="primary" size="small" @click="add_show = true; add_item = {}">+ 新建</el-button> -->
        </div>
        <div style="margin-top: 10px;padding: 0px 5px;">
            <el-tabs v-model="haowu_type" @tab-click="check_type">
                <el-tab-pane v-for="item in ku_type" :label="item.name" :name="item.name" :key="item.name"></el-tab-pane>
            </el-tabs>
        </div>

        <div style="margin-top: 0px;display: flex;flex-wrap: wrap;">
            <div v-for="(item, index) in list " :key="index" style="margin: 10px;" class="show-hide">
                <div style="display: flex;background-color: #fff;width: 200px;padding: 10px;border-radius: 10px;">
                    <div style="width: 80px;position: relative;" @click="make_show = true; make_item = item"
                        class="haowu_one">
                        <el-image style="width: 100%;height: 130px;border-radius: 5px;" fit="cover"
                            :src="item.cover"></el-image>
                        <div class="tree_other">
                            <div style="text-align: center;">
                                <i class="el-icon-scissors" style="font-size:30px;color: #fff;"></i>
                                <div style="color: #fff;font-size: 14px;font-weight: 600;">立即制作</div>
                            </div>
                        </div>
                    </div>
                    <div style="margin-left: 5px;">
                        <div style="font-size: 13px;">
                            {{ item.name }}
                        </div>
                        <div style="font-size: 12px;color: #666;">
                            费用:{{ item.surplus }}点
                        </div>
                        <div style="font-size: 12px;color: #dd0000;">
                            使用量:{{ item.dj }}次
                        </div>
                    </div>
                </div>


            </div>

        </div>

        <div v-if="list.length == 0" style="display: flex;justify-content: center;">
            <el-empty description="这里空空如也"></el-empty>
        </div>
        <div v-else style="margin-top: 10px;padding-bottom: 30px;">
            <el-pagination background layout="total,prev, pager, next" :page-size="18" :total="haowu_total"
                @current-change="fy_page" :current-page="haowu_page">
            </el-pagination>
        </div>

        <el-dialog title="立即制作" :visible.sync="make_show" custom-class="newdialog_share" top="10%">
            <div style="display: flex;">
                <el-image style="width: 80px;height: 130px;border-radius: 5px;" fit="cover"
                    :src="make_item.cover"></el-image>
                <div style="margin-left: 10px;">
                    <div style="font-size: 17px;">
                        {{ make_item.name }}
                    </div>
                    <div style="font-size: 13px;margin-top: 5px;margin-right: 10px;">
                        单个费用:{{ make_item.surplus }}点
                    </div>

                </div>
            </div>
            <div class="biaoqian">制作设置</div>
            <div style="margin-top: 10px;display: flex;align-items: center;justify-content: space-between;">
                <div>
                    制作数量
                </div>
                <el-input-number size="mini" v-model="make_num" style="margin-left: 10px;" :min="1"
                    :max="10"></el-input-number>
            </div>
            <div style="display: flex;justify-content: end;align-items: center;margin-top: 30px;">
                <div style="font-size: 13px;margin-top: 5px;margin-right: 10px;">
                    总费用:{{ make_item.surplus * make_num }}点
                </div>
                <el-button type="primary" size="medium" @click="make_fc">立即制作</el-button>
            </div>
        </el-dialog>

    </div>
</template>
  
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Balance from './Balance.vue';
export default {
    name: '',
    components: {
        Balance
    },
    // 定义属性
    data() {
        return {
            find_value: '',
            list: [],
            add_show: false,
            add_item: [],
            add_loading: false,
            videoFileList: [],
            imageFileList: [],
            dir_show: false,
            haowu_type: '全部',
            make_show: false,
            make_item: [],
            make_num: 1,
            ku_type: [],
            haowu_page: 1,
            haowu_total: 0,
            haowu_type: '全部',
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        fy_page(e) {
            this.haowu_page = e
            this.haowu_list()
        },
        check_type(tab, event) {
            console.log(tab.name)
            this.haowu_page = 1
            this.haowu_type = tab.name
            this.haowu_list()
        },
        make_fc() {
            console.log(this.make_item)
            const loading = this.$loading(this.$loadinginfo);
            var data = this.make_item
            data['num'] = this.make_num
            this.$ajax.post('/qhy/haowu/haowu_make', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                var jg = res.data
                if (res.data.status == 200) {
                    this.make_show = false
                    this.make_num = 1
                    this.make_item = []
                    this.$msg.success(res.data.msg)
                    this.$parent.$parent.$parent.$parent.get_balance()
                } else {
                    this.$msg.error(res.data.msg)
                }
                loading.close();
            })
        },
        haowu_list() {
            const loading = this.$loading(this.$loadinginfo);
            this.$ajax.post(
                '/qhy/haowu/haowu_tj_list?page=' + this.haowu_page +
                '&type=' + this.haowu_type +
                '&find=' + this.find_value
                ,
                { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                    console.log(res.data)
                    var jg = res.data
                    if (res.data.status == 200) {
                        this.list = jg.data.data
                        this.haowu_total = jg.data.total
                    }
                    loading.close();
                })
        },
        add_fc() {
            console.log(this.add_item)

            this.add_loading = true
            var data = this.add_item

            this.$ajax.post('qhy/haowu/haowu_add', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                // var jg = res.data
                if (res.data.status == 200) {
                    this.$msg.success(res.data.msg)
                    this.add_show = false
                    this.add_item = {}
                } else {
                    this.$msg.error(res.data.msg)
                }
                this.add_loading = false

            }).catch(err => {

                // console.log('failed', err);
            })
        },
        upload_kt(param, type) {
            // console.log(param,type)
            param.status = 'uploading';    //文件上传状态
            param.percentage = 0;    //文件上传进度，这里设为0
            param.name = param.file.name    //文件名

            if (type == 'video') {
                this.videoFileList.push(param)
            }
            if (type == 'image') {
                this.imageFileList.push(param)
            }

            let fdata = new window.FormData();
            fdata.append('file', param.file)
            fdata.append('key', 'ht')

            this.$ajax_upload.post('https://video.kissxx.cn/qhy/ht/savefile', fdata, {
                onUploadProgress: function (progressEvent) { // 处理上传进度事件
                    let percent = (progressEvent.loaded / progressEvent.total * 100).toFixed(0);   //计算出上传的进度，去整数位
                    param.percentage = percent;  //动态设置param的percentage
                    // console.info(percent)
                }
            }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(response => {
                //请求成功
                console.log(response.data);
                if (response.data.status == 200) {
                    param.status = 'success';  //上传成功后将status属性改成success
                    this.add_item[type] = response.data.url
                } else {
                    param.status = 'failed';
                    param.message = '上传失败';
                }
            }).catch(function (error) {
                // 请求失败处理
                console.log(error);
                param.status = 'failed';
                param.message = '上传失败';
            });


        },
        ku_type_list() {

            this.$ajax.post('/qhy/spk/ku_type_list', { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
                console.log(res.data)
                if (res.data.status == 200) {
                    this.ku_type = res.data.data
                    this.ku_type.unshift({ 'id': 0, 'name': '全部' });
                } else {
                    this.$msg.error(res.data.msg)
                }


            })
        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.haowu_list()
        this.ku_type_list()
        this.common.ismobile(this)
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
  
<style scoped>
.tree_other {
    display: none;

    position: absolute;
    bottom: 4px;
    top: 0;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 25%);
    border-radius: 5px;
    cursor: pointer;
}

.show-hide:hover .tree_other {
    display: flex;

}

/* .haowu_one:hover{
    box-shadow:0px 0px 20px 0px rgba(0,0,0,0.2) ;
  } */
</style>


// WEBPACK FOOTER //
// src/components/User/Haowu_tj.vue


// WEBPACK FOOTER //
// src/components/User/Haowu_tj.vue